import React from "react";
import PropTypes from "prop-types";
import {usePromiseTracker} from "react-promise-tracker";
import {ThreeDots} from "react-loader-spinner";
import "./loader.scss";

/** This component will display `ThreeDots` component of `react-loader-spinner`.
 *whenever `isLoading` prop is set to `true` or `false` loader will be displayed accordingly.
 if `isLoading` prop is not set then loader will be displayed based on promise which is being tracked by `react-promise-tracker` library */

const LoaderContainer = (props) => {
  const {promiseInProgress} = usePromiseTracker();
  const {isLoading = promiseInProgress} = props;

  return (
    <React.Fragment>
      {isLoading && (
        <div id="loader" className={"loader-container"} style={{zIndex: "999"}}>
          <div className={"loader-content"}>
            <ThreeDots
              color={getComputedStyle(document.documentElement).getPropertyValue(
                "--loader-color"
              )}
              height="100"
              width="100"
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default LoaderContainer;

LoaderContainer.propTypes = {
  /** if set to true loader will be shown */
  isLoading: PropTypes.bool,
};
